import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * MetaPixelTracker
 *
 * Fires fbq('track', 'PageView') on every client-side route change.
 * The initial PageView on hard load is already handled by the base
 * Meta Pixel code in public/index.html — this component only covers
 * subsequent SPA navigations where the page does NOT reload.
 *
 * Safe: skips silently if window.fbq is not defined.
 * Renders nothing (null).
 */
const MetaPixelTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Skip the very first render so we don't double-fire the
    // PageView that the base pixel already sent on initial load.
    // Every subsequent location change (client-side navigation)
    // will trigger a new PageView.
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'PageView');
    }
  }, [location.pathname]);

  return null;
};

export default MetaPixelTracker;
